// extracted by mini-css-extract-plugin
export default {"Label":"LinkTracking_Label__FnE+C"};